<div>
  <img src="assets/page-not-found.svg" alt="Page Not Found" />
  <h3>Oops! You're lost 👻</h3>
</div>
